function lerp(v0, v1, t) {
    return (1 - t) * v0 + t * v1;
}

function clamp(v, min, max) {
    return Math.max(Math.min(v, max), min);
}

function map(v, start1, stop1, start2, stop2) {
    return ((v - start1)/(stop1 - start1)) * (stop2 - start2) + start2;
}


export {
    lerp,
    clamp,
    map
}
